import smartSolveApi from './instances/smartsolve';

export const toggleArchiveMode = async (archiveMode) => {
  try {
    const response = await smartSolveApi.post('/archivemode', {
      ArchiveMode: archiveMode,
    });

    return response.data;
  } catch (e) {
    throw new Error(`toggleArchiveMode() failed: ${e}`);
  }
};
